import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RolesPermissionsComponent } from './roles-permissions.component';
import { CrudService } from 'src/app/services/crud/crud.service';
import { ConfirmationService, MessageService } from 'primeng/api';
import { EcoMaestroRolesPermissionsModule } from 'eco-maestro-roles-permissions';
@NgModule({
  declarations: [RolesPermissionsComponent],
  imports: [CommonModule, EcoMaestroRolesPermissionsModule],
  providers: [CrudService, ConfirmationService, MessageService],
})
export class RolesPermissionsModule {}
